import { Node } from "../node";

export class AllowBookingNode extends Node {
  get defaults() {
    return {
      id: "allow-booking",
      name: "AllowBookingNode",
    };
  }
}
